import { create } from 'zustand'
import { v4 as uuid } from 'uuid'

const usePersonaStore = create((set) => ({
  user_info: {
    isLoading: true,
  },
  quote: {
    isLoading: true,
  },
  health_advocate_profile: {
    isLoading: true,
  },
  moduleList: {
    [uuid()]: {
      cards: [],
    },
  },
  setField: (field, value) => set((state) => ({ ...state, [field]: value })),
  updateUserInfo: (field, value) =>
    set((state) => ({
      ...state,
      user_info: {
        ...state.user_info,
        [field]: value,
      },
    })),
  updateQuote: (index, value) =>
    set((state) => ({
      ...state,
      quote: {
        quote: (state.quote.quote || []).map((q, i) =>
          i === index ? value : q
        ),
      },
    })),
  updateHaP: (field, value) =>
    set((state) => ({
      ...state,
      health_advocate_profile: {
        ...state.health_advocate_profile,
        [field]: value,
      },
    })),
  init: () =>
    set((state) => ({
      ...state,
      user_info: {
        isLoading: true,
      },
      quote: {
        isLoading: true,
      },
      health_advocate_profile: {
        isLoading: true,
      },
    })),
}))

export default usePersonaStore
